import { electronModule } from 'sharedCodeDependencies';

const logger = {
  trace: trace,
  debug: debug,
  info: info,
  warn: warn,
  error: error,
  fatal: fatal,
};

export default logger;

export const loggingLevels = Object.keys(logger);

export function loggerForLevel(logger, level) {
  let log = () => {};
  if (logger) {
    switch (level) {
      case 'trace':
        log = logger.trace.bind(logger);
        break;
      case 'debug':
        log = logger.debug.bind(logger);
        break;
      case 'warn':
        log = logger.warn.bind(logger);
        break;
      case 'error':
        log = logger.error.bind(logger);
        break;
      case 'fatal':
        log = logger.fatal.bind(logger);
        break;
      case 'info':
      default:
        log = logger.info.bind(logger);
        break;
    }
  }

  return log;
}

function trace(...msg) {
  _log('trace', msg);
}

function debug(...msg) {
  _log('debug', msg);
}

function info(...msg) {
  _log('info', msg);
}

function warn(...msg) {
  _log('warn', msg);
}

function error(...msg) {
  _log('error', msg);
}

function fatal(...msg) {
  _log('fatal', msg);
}

const levelFromName = {
  'trace': 10,
  'debug': 20,
  'info': 30,
  'warn': 40,
  'error': 50,
  'fatal': 60,
};

function _log(level, msg) {
  if (electronModule) {// eslint-disable-line no-undef
    electronModule.ipcRenderer.send('log', {
      level: level,
      msg: msg
    });
  } else {
    // No Node logging package available in the browser, so just output to JS console.
    const clientLogLevel = (window && window.LOGLEVEL) || 'info';
    if (levelFromName[level] >= levelFromName[clientLogLevel]) {
      const args = msg
        .map(s => typeof s === 'object' ? JSON.stringify(s) : s)
        .join('');
      /* eslint-disable no-console */
      const errStr = `[${new Date().toISOString()}] ${level.toUpperCase()}: ${args}`;
      if (levelFromName[level] === levelFromName['warn']) {
        console.warn(errStr);
      } else if (levelFromName[level] >= levelFromName['error']) {
        console.error(errStr);
      } else {
        console.log(errStr);
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/portfolio-shared/util/logging.js